import { SOURCES } from './sources.js';

export const bellSchedule = {
  source: SOURCES.bellSchedulePdf,
  verificationNeeded: true,
  verificationNote:
    'Times shown are from the 2025-26 schedule with the 3/24/2026 start-time correction. The 2026-27 PDF has not yet been published by CRMS and may differ.',

  doorsOpen: '8:35 AM',
  doorsClose: '4:40 PM',
  earlyReleaseDismissal: '1:05 PM',
  firstBell: '9:00 AM',
  lastBell: '4:20 PM',

  schedules: [
    {
      id: 'monday-friday',
      label: 'Monday & Friday',
      days: ['Mon', 'Fri'],
      hasAdvisory: false,
      common: [
        { period: '1st', start: '9:00', end: '9:59' },
        { period: '2nd', start: '10:03', end: '10:58' },
      ],
      byGrade: {
        '6': [
          { period: '3rd', start: '11:02', end: '11:55' },
          { period: '4th', start: '11:59', end: '12:52' },
          { period: '5th', start: '12:56', end: '1:26', isLunch: true },
        ],
        '7': [
          { period: '3rd', start: '11:02', end: '11:55' },
          { period: '4th', start: '11:59', end: '12:29', isLunch: true },
          { period: '5th', start: '12:33', end: '1:26' },
        ],
        '8': [
          { period: '3rd', start: '11:02', end: '11:32', isLunch: true },
          { period: '4th', start: '11:36', end: '12:29' },
          { period: '5th', start: '12:33', end: '1:26' },
        ],
      },
      tail: [
        { period: '6th', start: '1:30', end: '2:24' },
        { period: '7th', start: '2:28', end: '3:22' },
        { period: '8th', start: '3:26', end: '4:20' },
      ],
    },
    {
      id: 'tues-wed-thurs',
      label: 'Tuesday, Wednesday & Thursday (Advisory)',
      days: ['Tue', 'Wed', 'Thu'],
      hasAdvisory: true,
      common: [
        { period: '1st', start: '9:00', end: '9:54' },
        { period: '2nd', start: '9:58', end: '10:48' },
        { period: 'Advisory', start: '10:52', end: '11:21' },
      ],
      byGrade: {
        '6': [
          { period: '3rd', start: '11:25', end: '12:14' },
          { period: '4th', start: '12:18', end: '1:07' },
          { period: '5th', start: '1:11', end: '1:41', isLunch: true },
        ],
        '7': [
          { period: '3rd', start: '11:25', end: '12:14' },
          { period: '4th', start: '12:18', end: '12:48', isLunch: true },
          { period: '5th', start: '12:52', end: '1:41' },
        ],
        '8': [
          { period: '3rd', start: '11:25', end: '11:55', isLunch: true },
          { period: '4th', start: '11:59', end: '12:48' },
          { period: '5th', start: '12:52', end: '1:41' },
        ],
      },
      tail: [
        { period: '6th', start: '1:45', end: '2:34' },
        { period: '7th', start: '2:38', end: '3:27' },
        { period: '8th', start: '3:31', end: '4:20' },
      ],
    },
  ],
};
